import React, { useCallback, useMemo, useState } from 'react';
import PropType from 'prop-types';
import { useField } from 'formik';
import classNames from 'classnames';

import FuelIcon from '@components/fuel-icon/FuelIcon';

export default function Rate({
  label,
  name,
}) {
  const [field, meta, helpers] = useField(name);
  const [ratingHover, setRatingHover] = useState(null);
  const classes = useMemo(() => classNames(
    'rating-field',
  ), [field, meta]);

  const calcIconColor = useCallback((index) => {
    if (index <= (ratingHover || field.value)) {
      return '#eb8705';
    }

    return '#a6a6a6';
  }, [field, ratingHover]);

  return (
    <div className={classes}>
      {!!label && (
        <label>
          {label}
        </label>
      )}
      <div className='rating-field__list'>
        <FuelIcon
          color={calcIconColor(1)}
          onMouseEnter={() => setRatingHover(1)}
          onMouseLeave={() => setRatingHover(null)}
          onClick={() => helpers.setValue(1)}
        />
        <FuelIcon
          color={calcIconColor(2)}
          onMouseEnter={() => setRatingHover(2)}
          onMouseLeave={() => setRatingHover(null)}
          onClick={() => helpers.setValue(2)}
        />
        <FuelIcon
          color={calcIconColor(3)}
          onMouseEnter={() => setRatingHover(3)}
          onMouseLeave={() => setRatingHover(null)}
          onClick={() => helpers.setValue(3)}
        />
        <FuelIcon
          color={calcIconColor(4)}
          onMouseEnter={() => setRatingHover(4)}
          onMouseLeave={() => setRatingHover(null)}
          onClick={() => helpers.setValue(4)}
        />
        <FuelIcon
          color={calcIconColor(5)}
          onMouseEnter={() => setRatingHover(5)}
          onMouseLeave={() => setRatingHover(null)}
          onClick={() => helpers.setValue(5)}
        />
      </div>
    </div>
  );
}

Rate.defaultProps = {
  label: '',
};

Rate.propTypes = {
  name: PropType.string.isRequired,
  label: PropType.node,
};
